import PageWrapper from '../components/PageWrapper';
import LegalDocLayout from '../components/marketing/LegalDocLayout';

const sections = [
  {
    id: 'introduction',
    title: 'Introduction',
    content: [
      'Stavyn ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our platform.',
      'Please read this policy carefully. If you disagree with its terms, please discontinue use of our services.',
      'We reserve the right to make changes to this Privacy Policy at any time and for any reason. We will alert you about any changes by updating the "Last Updated" date of this policy.',
    ],
  },
  {
    id: 'information-we-collect',
    title: 'Information We Collect',
    content: [
      'We collect information that you provide directly to us, such as when you create an account, request a demo, or contact us for support. This may include your name, email address, company name, job title, and phone number.',
      'We automatically collect certain information when you use our services, including log data (IP address, browser type, pages visited, time and date), device information, and usage data about how you interact with our platform.',
      'We may receive information about you from third-party sources, including HR information systems you connect to Stavyn, public professional profiles, and labor market data providers. This external market data is central to Stavyn\'s flight risk prediction capabilities.',
    ],
  },
  {
    id: 'how-we-use-information',
    title: 'How We Use Information',
    content: [
      'We use the information we collect to provide, maintain, and improve our services — including generating flight risk scores, retention recommendations, and market benchmark reports.',
      'We use your contact information to communicate with you about your account, respond to inquiries, and send service-related updates. We do not send unsolicited marketing communications without your consent.',
      'We analyze aggregated, anonymized data to improve our predictive models and product features. Individual employee data is never shared across organizations or used to train models in ways that could identify specific individuals.',
      'We may use your information to comply with applicable laws and regulations, enforce our terms, and protect the rights, property, and safety of Stavyn, our users, and others.',
    ],
  },
  {
    id: 'data-security',
    title: 'Data Security',
    content: [
      'We use administrative, technical, and physical security measures designed to protect your personal information. All data is encrypted in transit using TLS 1.3 and at rest using AES-256.',
      'Access to personal data within Stavyn is restricted on a need-to-know basis, with access logs maintained for all sensitive data operations.',
      'While we have implemented safeguards designed to protect your information, no security system is impenetrable. We cannot guarantee that information will never be accessed, disclosed, altered, or destroyed through a breach of our security measures.',
    ],
  },
  {
    id: 'data-retention',
    title: 'Data Retention',
    content: [
      'We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your data at any time.',
      'Employee data imported into Stavyn for retention analysis is stored only for the duration of your active subscription, plus a 90-day grace period following cancellation.',
      'Some data may be retained longer where required by law or legitimate business purposes, such as financial transaction records.',
    ],
  },
  {
    id: 'third-party-services',
    title: 'Third-Party Services',
    content: [
      'We may share your information with trusted third-party service providers who assist us in operating our platform, conducting business, or serving users, as long as those parties agree to keep this information confidential.',
      'Stavyn integrates with HRIS platforms (such as ADP, Workday, BambooHR, and others) at your direction. When you connect these integrations, data flows are governed by your organizational settings and applicable data processing agreements.',
      'We do not sell, trade, or rent your personal information to third parties for their marketing purposes.',
    ],
  },
  {
    id: 'your-rights',
    title: 'Your Rights',
    content: [
      'You have the right to access, correct, or delete your personal information. You can exercise these rights through your account settings or by contacting us directly.',
      'If you are located in the European Economic Area (EEA) or United Kingdom, you have additional rights under GDPR/UK GDPR, including the right to data portability, the right to restrict processing, and the right to lodge a complaint with a supervisory authority.',
      'California residents have additional rights under CCPA, including the right to know what personal information is collected, the right to deletion, and the right to opt-out of the sale of personal information (we do not sell personal information).',
    ],
  },
  {
    id: 'contact',
    title: 'Contact Information',
    content: [
      'If you have questions or concerns about this Privacy Policy, please contact us at hello@stavyn.com. We will respond within 30 business days.',
    ],
  },
];

export default function PrivacyPage() {
  return (
    <PageWrapper>
      <LegalDocLayout
        title="Privacy Policy"
        lastUpdated="March 1, 2026"
        sections={sections}
        crossLinkTo="/terms"
        crossLinkLabel="Terms of Service"
      />
    </PageWrapper>
  );
}
